<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择地址"
      width="900px"
      top="8vh">
    <table-select
        ref="tableSelect"
        :filter="filter"
        :columns="columns"
        module="basic"
        url="customerDeliveryAddress"
        @select="selectAddress"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter">
          <el-form-item label="详细地址" prop="addressDetail">
            <el-input v-model.trim="filter.addressDetail" placeholder="请输入详细地址" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    components: { TableSelect },

    data() {
      return {
        dialogVisible: false,
        filter: {
          customerId: "",
          addressDetail: "",
        },
        columns: [
          {
            title: "所属区域",
            key: "districtName",
            width: 260,
          },
          {
            title: "详细地址",
            key: "addressDetail",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
          },
        ],
      };
    },
    methods: {
      open(customerId) {
        this.dialogVisible = true;
        this.filter.customerId = customerId;
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.$refs.tableSelect.loadData();
        });
      },

      selectAddress(row) {
        this.dialogVisible = false;
        this.$emit("select", row);
      },

      resetHandle(filter) {
        this.filter = filter;
        this.$nextTick(() => {
          this.$refs.tableSelect.loadData();
        });
      },
    },
  };
</script>
